export default "__VITE_ASSET__lHQktAfI__"